import type { IFontsTheme } from "./types"
import { defaultWeights } from "./types"

const fonts: IFontsTheme = {
  default: {
    weights: defaultWeights,
    defaultWeight: "Regular",
    family: undefined,
  },
}

export default fonts
